import { Checks } from "./setting"

export enum SPLBCategory {
  XYKCXX = Checks.XYKCXX,
  ZCYKCXX = Checks.ZCYKCXX,
  ZYKCXX = Checks.ZYKCXX,
  CLKCXX = Checks.CLKCXX,
  QTKCXX = Checks.QTKCXX,
  XLKCXX = Checks.XLKCXX,
  FLKCXX = Checks.FLKCXX,
}

export const SPLBCategoryCategories = [
  SPLBCategory.XYKCXX,
  SPLBCategory.ZCYKCXX,
  SPLBCategory.ZYKCXX,
  SPLBCategory.CLKCXX,
  SPLBCategory.QTKCXX,
  SPLBCategory.XLKCXX,
  SPLBCategory.FLKCXX,
]

export function getRecipeNormalFrequencyName(
  category: SPLBCategory
): string {
  switch (category) {
    case SPLBCategory.XYKCXX:
      return '西药'
    case SPLBCategory.ZCYKCXX:
      return '中成药'
    case SPLBCategory.ZYKCXX:
      return '中草药'
    case SPLBCategory.CLKCXX:
      return '材料'
    case SPLBCategory.QTKCXX:
      return '其他'
    case SPLBCategory.XLKCXX:
      return '细料'
    case SPLBCategory.FLKCXX:
      return '辅料'
  }
  return ''
}